import { StyleSheet } from 'react-native';
import {
    BLUE_COLOR, PRIMARY_COLOR,
} from 'coooltv-js-shared/src/styles/common';
import { GREY_COLOR } from 'src/styles/common';

const styles = StyleSheet.create({
    second_inputs: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    filters_wrapper: {
        color: GREY_COLOR,
        fontSize: 24,
        marginTop: 10,
        marginBottom: 40,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
    },
    filters_wrapper_phone: {
        fontSize: 18,
        alignItems: 'start',
        color: GREY_COLOR,
        marginBottom: 20,
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    filter_wrapper: {
        width: '48%',
    },
    filter_wrapper_phone: {
        marginVertical: 5,
        width: '100%',
    },
    filter_inputs: {
        fontFamily: 'Open Sans',
        fontWeight: 300,
        fontSize: 16,
        color: GREY_COLOR,
        width: '48%',
        height: 40,
        borderWidth: 1,
        borderStyle: 'solid',
        paddingHorizontal: 10,
        borderColor: BLUE_COLOR,
        borderRadius: 8,
    },
    added_channels_labels_phone: {
        color: GREY_COLOR,
        fontSize: 16,
        textAlign: 'center',
        width: '50%',
    },
    internal_wrapper: {
        marginLeft: 30,
    },
    image_style: {
        height: 120,
        width: 120,
        margin: 5,
    },
    choice_image_style_phone: {
        height: 80,
        width: 80,
        margin: 5,
    },
    filter_text: {
        color: GREY_COLOR,
        fontSize: 16,
    },
    right_arrow_style: {
        transform: 'rotate(180deg)',
    },
    selected_profile_image: {
        borderColor: PRIMARY_COLOR,
        borderStyle: 'solid',
        borderWidth: 3,
        borderRadius: 28,
    },
    selected_profile_image_phone: {
        borderColor: PRIMARY_COLOR,
        borderStyle: 'solid',
        borderWidth: 3,
        borderRadius: 18,
    },
    choice_image_wrapper: {
        margin: 20,
    },
    choice_image_wrapper_phone: {
        margin: 5,
    },
    choice_images_wrapper: {
        flexDirection: 'row',
        alignSelf: 'center',
    },
    carousel_wrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        marginVertical: 40,
    },
    avatar_choice_label: {
        marginTop: 40,
        alignSelf: 'center',
        width: '100%',
        color: GREY_COLOR,
        fontSize: 24,
    },
    avatar_choice_label_phone: {
        marginTop: 40,
        marginLeft: 8,
        alignSelf: 'center',
        width: '100%',
        color: GREY_COLOR,
        fontSize: 18,
    },
    device_wrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'center',
        flexWrap: 'wrap',
        maxWidth: '100%',
        marginTop: 20,
    },
    device_wrapper_phone: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-around',
        textAlign: 'center',
        flexWrap: 'wrap',
        maxWidth: '100%',
        marginTop: 40,
    },
    device_container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    device_container_phone: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    device_icon_container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 20,
    },
    checkbox: {
        margin: 0,
        padding: 0,
    },
    device_text: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: GREY_COLOR,
        fontSize: 16,
        minHeight: 64.5,
        maxWidth: 195,
        wordBreak: 'break-all',
        alignSelf: 'center',
        marginVertical: 5,
    },
    device_text_phone: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: GREY_COLOR,
        fontSize: 10,
        minHeight: 64.5,
        maxWidth: 122,
        wordBreak: 'break-all',
        alignSelf: 'center',
        marginVertical: 5,
    },
    device_buttons_wrapper: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'center',
    },
    device_box: {
        maxWidth: 195,
        marginHorizontal: 40,
    },
    device_box_phone: {
        maxWidth: 195,
        marginHorizontal: 10,
    },
});

export default styles;
